// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <p>The VA's FHIR Health APIs allow consumers to develop applications using Veteran data. Please see the tabs below for the specific FHIR implementations. Data entered through the production environment Veterans Health API is held in the original data source for 36 hours before it is visible elsewhere, including in any patient-facing applications. This holding period exists to allow health care providers time to discuss health data, such as sensitive diagnoses, before the patient sees this data elsewhere.</p>
      <p>The following Veteran data is excluded from the 36 hour hold:</p>
      <ul>
      <li>COVID lab tests</li>
      <li>All immunizations</li>
      </ul>
      <blockquote>
      <p><strong>NOTICE</strong>: Lighthouse encourages using the R4 specification to conform with the <a href="https://www.federalregister.gov/documents/2020/05/01/2020-07419/21st-century-cures-act-interoperability-information-blocking-and-the-onc-health-it-certification#h-13">21st Century Cures Act</a>, which requires adoption of R4 by December 31, 2022.</p>
      </blockquote>
    </div>
  );
};

export default MarkdownComponent;
